export const psychologyIq = {
    'meta': {
        'title': 'Badanie poziomu intelektu #cityLocativeIn# • Centrum COLLIGO',
        'description': 'Badanie poziomu inteligencji #cityLocativeIn#. Badanie przeprowadzane przez wykształconych i doświadczonych specjalistów w bezpiecznym i przyjaznym otoczeniu.'
    },
    'availability': [
        'torun'
    ],
    'url': {
        'address': '#cityIdUrl#/uslugi/badanie-poziomu-intelektu/',
        'title': 'Badanie poziomu inteligencji #cityLocativeIn#',
        'name': 'Badanie poziomu intelektu #cityLocativeIn#',
        'heading': 'Badanie poziomu intelektu #cityLocativeIn#',
        'fullName': 'Badanie poziomu intelektu'
    },
    'image': {
        'url': '/images/services/badanie-poziomu-intelektu.webp',
        'width': 886,
        'height': 295,
        'alt': 'Badanie poziomu inteligencji'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/badanie-poziomu-intelektu.webp',
            'width': 886,
            'height': 295,
            'alt': 'Badanie poziomu inteligencji'
        }
    }
}